import React from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar'

import List, {ListItem, ListItemSecondaryAction, ListItemText} from 'material-ui/List';
import Switch from 'material-ui/Switch';
import Avatar from 'material-ui/Avatar';
import Divider from 'material-ui/Divider';

import Paper from 'material-ui/Paper';
import Dialog, {
    DialogActions, 
    DialogContent, 
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';
import Grid from 'material-ui/Grid';
import {DatePicker} from 'material-ui-pickers';
import moment from 'moment-timezone';

import {Add, FilterList, Edit, Visibility, VisibilityOff, Delete} from 'material-ui-icons';

import tsl from '../../../tsl';

import axios from 'axios';

import EventForm from './EventForm';
import CalendarForm from './CalendarForm';
import FlightDetail from './../../flights/routes/Detail';
import { connect } from 'react-redux';
import { hideCalendar, showCalendar, calendarsLoaded } from "actions/Calendars";

// https://github.com/intljusticemission/react-big-calendar/issues/255
import 'react-big-calendar/lib/css/react-big-calendar.css';



class Basic extends React.Component {

    state = {
        date: moment().toDate(),
        view: "week",
        views: ["month","week","day"],
        calendars: {},
        flights: [],
        showAvailableEvents: false, // if to display in calendar events with flag Available
        selected_event: null,
        selected_calendar: null,
        calendars_dialog: false,
    };

    defaultMin = 5;
    defaultMax = 21;

    constructor(props) {
        super(props);

        const currentDate = moment();

// Set the desired start and end times for the timeline
        const minTimeToDisplay = currentDate.clone().startOf('day');
        const maxTimeToDisplay = currentDate.clone().endOf('day');

        this.state = {
            ...this.state,
            minTimeToDisplay,
            maxTimeToDisplay,
            displayFullTimeRange: false
        }
    }

    componentDidMount() {
        axios.get('/api/operator/calendar')
            .then((res) =>{
                let calendars = {};
                for (let i in res.data) {
                    const calendarData = res.data[i];
                    calendars[calendarData.id] = this.prepareCalendar(calendarData);
                }
                this.setState({
                    calendars: calendars
                });

                this.props.calendarsLoaded(calendars);
                
                this.loadCalendarEvents(Object.keys(calendars));
            }, this);

    }

    prepareCalendar = (calendar) => {
        calendar.events = [];
                    
        // if calendar is related to aircraft, try to rewrite name by aircraft registration number
        if (calendar.aircraft) {
            calendar.name = calendar.aircraft.reg_no || calendar.name;
        }

        return calendar;
    }

    loadCalendarEvents = (calendar_ids) => {
        axios.get('/api/operator/calendar/'+calendar_ids.join(',')+'/events')
            .then((res) => {
                let calendars = this.state.calendars;
                
                // clear events of calendars (new ones will be set)
                for (let i in calendars) {
                    calendars[i].events = [];
                }
                
                let flightIDsToLoad = []; // collect IDs of flights related to some calendar events

                for (let i in res.data) {
                    const event = res.data[i];
                    calendars[event.calendar_id].events.push(event);
                    if (event.flight) {
                        flightIDsToLoad.push(event.flight.id);
                    }
                }

                this.loadFlightDetails(flightIDsToLoad);
                
                this.setState({
                    calendars: calendars
                }, this.updateDisplayedTimeRange);

            });
    }

    loadFlightDetails = (ids) => {
        axios.get('/api/operator/flights?id=' + ids.join(',') + '?perPage=1000')    // to not paginate, if 1000 is not enough, problem is in architecture
            .then(res => {
                this.setState({ flights: res.data.data }); // 'data' key/attribute of request (request data are in res.data)
            });
    }

    saveEvent = () => {
        const event = {
            ...this.state.selected_event
        };

        if (event.all_day) {
          event.time_start = moment(event.time_start).startOf('day');
          event.time_end = moment(event.time_end).endOf('day');
        }

        let calendar_id = event.calendar_id;

        axios.post('/api/operator/calendar/'+calendar_id+'/events', {
                id: event.id || null,
                title:  event.title,
                description:  event.description,
                time_start: moment(event.time_start).format('YYYY-MM-DD HH:mm:ss'),
                time_end: moment(event.time_end).format('YYYY-MM-DD HH:mm:ss'),
                all_day: event.all_day,
                is_available: event.is_available,
            })
            .then((res) => {
                this.closeEventDialog();
                this.loadCalendarEvents(this.props.calendars_displayed);
            });
    }

    deleteEvent = (event) => () => {
        axios.delete('/api/operator/calendar/'+event.calendar_id+'/events/'+event.id)
            .then(res => {
                this.closeEventDialog();
                this.loadCalendarEvents(this.props.calendars_displayed);
            })
    };

    getEvents = () => {
        let events = [];
        //console.log('adding calendars', this.state.calendars_displayed);
        for (let i in this.props.calendars_displayed) {
            const cal_id = this.props.calendars_displayed[i];
            const calendar = this.state.calendars[cal_id];
            if (!calendar) continue;

            events = events.concat(calendar.events
                .filter(event => {  // filter events to display
                    if (!this.state.showAvailableEvents && event.is_available) {
                        // setting to hide available event and event is available
                        return false;   // do not display
                    } else {
                        return true;    // otherwise -> display
                    }
                })
                .map((event) => {   // transform displayed events

                    // if is related event to flight
                    if (event.flight) {
                        // set default title of event - title of flight offer
                        event.title = event.flight.aircraft_offer.flight_offer.title;
                    }

                    // updating to structure for calendar
                    event.start = moment(event.time_start).toDate();
                    event.end = moment(event.time_end).toDate();
                    // if event ends at midnight, display it as ending 1 minute before midnight,
                    // so it would overlap to next day
                    if (event.end.getHours() == 0 && event.end.getMinutes() == 0) {
                        event.end.setHours(0, -1);
                    }
                    event.color = calendar.color_hex;
                    event.calendar_id = calendar.id;    // artificial column for editation to pre-select calendar
                    event.allDay = event.all_day;
                    return event;
                })
            );
        }

        /* flights displayed as synchronized calendar events
        for (let i in this.state.flights) {
            const flight = this.state.flights[i];
            if (!flight.aircraft) {
                continue;   // if flight has no assigned aircraft - no calendar to display in
            }

            const offer = flight.aircraft_offer.flight_offer;
            let event = {
                start: new Date(flight.start_time),
                end: new Date(moment(flight.start_time).add(offer.time_flight + offer.time_after, 'minutes')),
                color: flight.aircraft.calendar.color_hex,
                title: offer.title,
                flight: flight,
            }
            events.push(event);
        }
        // */

        //console.log(events);
        return events;
    }

    onSelectEvent = (event) => {
        this.setState({
            selected_event: event
        })
    }

    onSelectSlot = (slot) => {
        const event = {
            title: '',
            time_start: moment(slot.start).format('YYYY-MM-DD HH:mm:ss'),
            time_end: moment(slot.end).format('YYYY-MM-DD HH:mm:ss'),
            all_day: false
        };
        
        this.setState({
            selected_event: event
        })
    }

    handleNewEvent = () => {
        const start = moment();

        if (start.minutes() >= 30) {
            start.add(1, 'h').startOf('hour')
        } else {
            start.startOf('hour').add(30, 'm');
        }

        return this.onSelectSlot({
           start,
           end: moment(start).add(30, 'm')
        });
    }

    changeEvent = (event, callback) => {
        this.setState({
            selected_event: event
        }, callback);
    }

    changeView = (view) => {
        this.setState({
            view: view
        });
    }


    changeDate = (date, view) => {
        this.setState({
            date: date
        });
    }

    handleSwitchChange = (attr) => (e, checked) => {
        let state = this.state;
        state[attr] = checked;
        this.setState(state);
    }

    getEventTitle = (event) => {
        const eventTitlePrefix = 
                event.is_available
                    ? <i className="zmdi zmdi-circle-o" style={{float: 'left'}} key={1}>&nbsp;</i>
                    : ''
                ;

        return [
            <span key={1}>{eventTitlePrefix}</span>,
            <span key={2}>{event.title}</span>
        ];
    }

    getEventStyle = (event) => {
        const style = {
            backgroundColor: (event.color || '#303040'),
            border: 'none',
            borderLeft: "2px " + (event.color || '#303040') + " solid",
            borderRadius: 1, 
        }

        return {style: style};
    }

    closeEventDialog = () => {
        this.setState({
            selected_event: null
        });
    }

    toggleCalendarsDialog = (value) => () => {
        this.setState({
            calendars_dialog: value
        });
    }

    saveCalendar = () => {
        axios.post('/api/operator/calendar', this.state.selected_calendar)
            .then((res) => {
                // add calendar to list of calendars
                let newCalendars = this.state.calendars;
                newCalendars[res.data.id] = this.prepareCalendar(res.data);
                this.setState({ calendars: newCalendars });
                this.props.calendarsLoaded(newCalendars);

                this.handleChangeCalendarDisplay(res.data.id, true);  // add new calendar to displayed ones
                this.loadCalendarEvents(this.props.calendars_displayed);
                this.closeCalendarDialog();
            })
    }

    deleteCalendar = (calendar) => () => {
        axios.delete('/api/operator/calendar/' + calendar.id)
            .then(res => {
                this.closeCalendarDialog();
                this.handleChangeCalendarDisplay(calendar.id, false).call();
                let calendars = {};
                for (let id in this.state.calendars) {
                    if (id != calendar.id) {
                        calendars[id] = this.state.calendars[id];
                    }
                }
                this.setState({ calendars:  calendars });
                this.props.calendarsLoaded(calendars);
            })
    }

    changeCalendar = (calendar) => {
        this.setState({
            selected_calendar: calendar
        });
    }

    editCalendar = (calendar) => () => {
        this.toggleCalendarsDialog(false);
        this.setState({
            selected_calendar: calendar
        });
    }

    handleAddCalendar = () => {
        this.setState({
            selected_calendar: {
                name: '',
                color_hex: '#000',
            } 
        });
    }

    closeCalendarDialog = () => {
        this.setState({
            selected_calendar: null
        });
    }

    handleChangeCalendarDisplay = (changeId, show = null) => () => {
        let displayed = this.props.calendars_displayed;

        if (show === null) {
            // if show is not explicitelly defined, set show to oposite of current status (hidden -> show, show -> hidden)
            show = (displayed.indexOf(changeId) === -1)
            //console.log('determined SHOW', show);
        }

        if (show) {
            this.props.showCalendar(changeId);
        } else {
            this.props.hideCalendar(changeId);
        }
    };

    renderEventDialog() {
        const selected_event = this.state.selected_event;

        if (!selected_event) {
            return null;
        }

        if (selected_event.flight) {
            // filter flights to only where ID is id of selected flight event, and pop from this result array (get one result to var.)
            const flightData = this.state.flights.filter(flight => flight.id == selected_event.flight.id).pop();

            return (
                <Dialog onClose={this.closeEventDialog} open={selected_event != null} >
                    <DialogTitle>{tsl('calendar.eventform.header')}</DialogTitle>
                    <DialogContent>
                      
                        <FlightDetail 
                            flight={flightData}
                        />

                    </DialogContent>
                </Dialog>
            );
        } else {
            return (
                    <EventForm
                        event={selected_event || {}}
                        onChange={this.changeEvent}
                        calendars={Object.values(this.state.calendars)}
                        onDelete={this.deleteEvent(selected_event)}
                        onClose={this.closeEventDialog}
                        onSave={this.saveEvent}
                    />
            );
        }
    }

    getTooltip = (event) => {
        const calendar = this.state.calendars[event.calendar_id];

        return `\n${event.title}\n${calendar.name}\n${event.description || '-'}`;
    };

    render() {
        if (null === this.props.calendars_displayed) {
            // wait until all calendars are loaded to redux
            return null;
        }
        const localizer = momentLocalizer(moment)

        const events = this.getEvents();
        const selected_calendar = this.state.selected_calendar;
        const {
          minTimeToDisplay,
          maxTimeToDisplay,
          displayFullTimeRange
        } = this.state;

        // const minTime = displayFullTimeRange || minTimeToDisplay.getHours() == 0 && minTimeToDisplay.getMinutes() == 0 ? undefined : minTimeToDisplay;
        // const maxTime = displayFullTimeRange || maxTimeToDisplay.getHours() == 23 && maxTimeToDisplay.getMinutes() == 59 ? undefined : maxTimeToDisplay;
        const minTime = minTimeToDisplay.toDate();
        const maxTime = maxTimeToDisplay.toDate();
        console.log(minTime);
        console.log(maxTime);
        return (<div>

            {!selected_calendar ? '' :
                    <CalendarForm
                        calendar={selected_calendar || {}}
                        onChange={this.changeCalendar}
                        onDelete={this.deleteCalendar(selected_calendar)}
                        onClose={this.closeCalendarDialog}
                        onSave={this.saveCalendar}
                    />
            }

            {this.renderEventDialog()}

            <Dialog onClose={this.toggleCalendarsDialog(false)} open={this.state.calendars_dialog} >
                <DialogTitle>{tsl('calendar.calendars_management')}</DialogTitle>
                <DialogContent>
                  
                    {Object.values(this.state.calendars).map((calendar, index) => {
                        return (
                            <ListItem button key={index} onClick={this.handleChangeCalendarDisplay(calendar.id)}>
                                <Avatar style={{color: 'white', backgroundColor: calendar.color_hex}}>
                                    {this.props.calendars_displayed.indexOf(calendar.id) === -1
                                        ? <VisibilityOff />
                                        : <Visibility />
                                    }
                                </Avatar>
                                <ListItemText primary={calendar.name} />
                                {calendar.aircraft ? '' :  
                                    <ListItemSecondaryAction>
                                        <IconButton onClick={this.editCalendar(calendar)}>
                                            <Edit />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                }
                            </ListItem>
                        );
                    })}

                    <Divider light />

                    <ListItem button onClick={this.handleAddCalendar}>
                                <Avatar style={{color: 'white', backgroundColor: '#ccc'}}>
                                    <Add />
                                </Avatar>
                                <ListItemText primary={tsl('calendar.management.add')} />
                    </ListItem>

                </DialogContent>
                <DialogActions>
                    <Button onClick={this.toggleCalendarsDialog(false)} color="primary">
                        {tsl('calendar.management.ok')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Button fab className="text-white" color="accent" 
                style={{position: "fixed", right: 30, bottom: 10, zIndex: 9999}}
                onClick={this.handleNewEvent}
            >
                <Add />
            </Button>

            <Button fab className="text-white jr-btn-fab-sm" color="default" 
                style={{position: "fixed", right: 100, bottom: 10, zIndex: 9999}}
                onClick={this.toggleCalendarsDialog(true)}
            >
                <FilterList />
            </Button>

            <Paper style={{padding: 20}}>
                <Grid container spacing={16}>

                    <Grid item sm={4} xs={12}>
                        <DatePicker
                            fullWidth
                            label={tsl('calendar.overview.date_focus')}
                            value={this.state.date}
                            format={"LL"}
                            onChange={(m) => {this.changeDate(m.toDate())}}
                            leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                            rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                        />
                    </Grid>  

                    <Grid item sm={4} xs={6}>
                        <Switch
                            checked={this.state.showAvailableEvents}
                            onChange={this.handleSwitchChange('showAvailableEvents')}
                            aria-label="showAvailableEvents"
                        />
                        {tsl('calendar.overview.show_available_events')}
                    </Grid>

                    <Grid item sm={4} xs={6}>
                        <Switch
                            checked={this.state.displayFullTimeRange}
                            onChange={this.handleSwitchChange('displayFullTimeRange')}
                            aria-label="displayFullTimeRange"
                        />
                        {tsl('calendar.overview.display_full_time_range')}
                    </Grid>

                </Grid>
                <br />
                <Calendar
                    localizer={localizer}
                    events={events}
                    onNavigate={this.changeDate}
                    views={this.state.views}
                    onView={this.changeView}
                    view={this.state.view}
                    selectable={true}
                    toolbar={true}
                    eventPropGetter={this.getEventStyle}
                    titleAccessor={this.getEventTitle}
                    step={15}
                    onSelectSlot={this.onSelectSlot}
                    onSelectEvent={this.onSelectEvent}
                    style={{minHeight: 600}}
                    tooltipAccessor={this.getTooltip}
                    min={minTime}
                    max={maxTime}
                    startAccessor="start"
                    endAccessor="end"
                />
            </Paper>
        </div>);
    }

}

const mapStateToProps = state => ({
  calendars: state.calendars.list,
  calendars_displayed: state.calendars.displayed
});

const mapDispatchToProps = ({
  hideCalendar,
  showCalendar,
  calendarsLoaded
});

export default connect(mapStateToProps, mapDispatchToProps)(Basic);


// WEBPACK FOOTER //
// ./app/used/calendar/routes/Basic.js